<script>
    //Events to emit so '.native' is not necessary
    let events = ['change', 'keyup', 'keydown', 'keypress', 'copy', 'cut', 'paste'];

    export default {
        props: ["value", "saved", "placeholder", "disabled"],
        methods: {
            valueChanged(e) {
                this.changed = true;
            }
        },
        data() {
            return {
                changed: false
            }
        },
        mounted() {
            events.forEach(event => 
                this.$refs.input.addEventListener(event, e => 
                    this.$emit(event, e)
                )
            );
        },
        watch: {
            saved(val) {
                if(val) {
                    this.changed = false;
                }
            }
        }
    }
</script>
<template>
    <input ref="input" @change="valueChanged" @input="$emit('input', $event.target.value)" :class="{ changed: changed, 'disabled-input': disabled }" :value="value" :placeholder="placeholder" :disabled="disabled">
</template>

<style lang="less" scoped>
    @import "~less-variables";

    .disabled-input {
        opacity: 1;
        color: @ibe-text--dark-gray;
        background-color: @inputDisabledBackground;
        font-weight: 500;
    }
</style>